module.exports = "../img/imagen-placeholder-cine.png";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/imagen-placeholder-cine.png
// module id = 62
// module chunks = 0